import { options } from 'components/alerts/alertsCarousel/options';
import { observable } from 'mobx';
import { WidgetOptionsImpl } from 'models/Widget/WidgetOptions';
import { HyperSpaceAlertsWidgetOptions } from './types';

export class HyperSpaceAlertsWidgetOptionsImpl extends WidgetOptionsImpl
    implements HyperSpaceAlertsWidgetOptions {
    @observable alertMessage = options;
}
